import { Button, Col, Container, Form, ListGroup, Modal, Nav, Navbar, Offcanvas, Overlay, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import { useContext, useRef, useState } from "react";
import { NavigationContext } from "../../Context/NavigationContext";
import { NavObjectType, lddGlobalSessionInfo } from "../../Components/navigationTypes";
import { useAppSelector } from "../../redux/hooks";
import '../../Components/mainbar.css';
const OpenMainPage: NavObjectType = { component: "formlist" };
const OpenBilling: NavObjectType = { component: "billing" };


const GetAccountName = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return <>loading...</>;
    }
    if (sessionInfo.isLDDUser) {
        return sessionInfo.firm.account;
    } else {
        return sessionInfo.user.fullname;
    }
}
const GetFullName = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return <>loading...</>;
    }
    return sessionInfo.user.fullname;
}

const GetInitials = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return "...";
    }
    return sessionInfo.user.initials;
}

function SidebarTitle(title: string) {
    return (
        <h4>{title}</h4>
    )
}

function SidebarAction(title: string, click: NavObjectType, sid: string, nav: Function, closeSidebar: Function) {
    return (
        <ListGroup.Item action onClick={() => { nav(click); closeSidebar() }}>{title}</ListGroup.Item>
    )
}

function ShowManageUsers(sid: string) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (<>
        <ListGroup.Item action onClick={handleShow}>Manage Users</ListGroup.Item>
        <Modal show={show} onHide={handleClose} className="modal-settings" backdrop={false}>
            <Modal.Header closeButton>
                <Modal.Title>Manage Users</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe title="User Management" src={`${window.location.origin}/${process.env.REACT_APP_UM_ENDPOINT}/index.html?SessionID=${sid}`} width="100%" height="100%" />
            </Modal.Body>
        </Modal>
    </>)
}

function toggleDarkTheme(e) {
    var checked = e.target.checked;
    var val = (checked) ? 1 : 0;
    setCookie('darkMode', val, 365);
    framesChangeClass("dark", checked);
}

export function setTheme() {
    framesChangeClass("dark", isDarkTheme())
}

export function isDarkTheme() {
    var val = getCookie("darkMode") === "1";
    if (val && !document.body.classList.contains('dark')) {
        document.body.classList.add("dark");
        setTheme();
    }
    return val;
}

function framesChangeClass(className: string, add: boolean) {
    if (add) {
        document.body.classList.add(className);
        document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
        document.body.classList.remove(className);
        document.documentElement.setAttribute('data-bs-theme', 'light')
    }
    var allFrames = document.getElementsByTagName("iframe");
    for (var i = 0; i < allFrames.length; i++) {
        if (allFrames[i].src.toLowerCase().indexOf(`${window.location.origin}/dr/`) === -1) {
            var tmp = allFrames[i].contentDocument.body;
            if (add) {
                tmp.classList.add(className);
                document.documentElement.setAttribute('data-bs-theme', 'dark')
            } else {
                tmp.classList.remove(className);
                document.documentElement.setAttribute('data-bs-theme', 'light')
            }
        }
    }
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function ShowSettingsCanvas(sid: string, SessionInfo: lddGlobalSessionInfo, props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const nav = useContext(NavigationContext);
    return (
        <>
            <Nav.Item className="item">
                <OverlayTrigger placement="bottom" delay={200} overlay={
                    <Tooltip>Settings</Tooltip>
                }>
                    <Nav.Link eventKey="link-4"><i className="fa-light fa-gear fa-indicator" onClick={handleShow}></i></Nav.Link>
                </OverlayTrigger>
            </Nav.Item>

            <Offcanvas show={show} onHide={handleClose} placement="end" className="settings-menu" scroll>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Settings</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <div className="settings-tabs">

                        {SidebarTitle("Account")}

                        <ListGroup variant="flush">
                            {SessionInfo.user.isAdmin && ShowManageUsers(sid)}
                        </ListGroup>

                        <hr className="sm" />

                        {SidebarTitle("Billing")}

                        <ListGroup variant="flush">
                            <ListGroup.Item action onClick={() => window.open(`${process.env.REACT_APP_DR_ENDPOINT}/LawyerAccounting.asp?SessionID=${SessionInfo.sid}&NoHeader=1`, "_top")}>Billing Statements</ListGroup.Item>
                        </ListGroup>

                        <hr className="sm" />

                        {SidebarTitle("Help & Support")}

                        <ListGroup variant="flush">
                            <ListGroup.Item action onClick={() => window.open("https://lawyerdonedeal.zohodesk.com/portal/en/kb/ldd")}>Knowledge Base</ListGroup.Item>
                        </ListGroup>

                        <hr className="sm" />
                    </div>
                </Offcanvas.Body>
            </Offcanvas >
        </>
    );
}

const TopBar = (props) => {
    const nav = useContext(NavigationContext);
    const sid: string = useAppSelector((state) => state.SessionID);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [targetAccount, setTargetAccount] = useState(null);
    const [showAccount, setShowAccount] = useState(false);
    const profileRef = useRef(null);
    const refAccount = useRef(null);
    const handleAccountClick = (event) => {
        setShowAccount(!showAccount);
        setTargetAccount(event.target);
    }

    function logout() {
        window.location.href = `/lddlogout.asp?SessionID=${sid}`;
    }

    return <>
    <Navbar className="nav-global">
        <OverlayTrigger placement="bottom" delay={200} overlay={
            <Tooltip>Home</Tooltip>
        }>
            <span className="logo">
                <img src={process.env.PUBLIC_URL+"/logo-ds.png"} alt="RW" onClick={() => nav(OpenMainPage)}/>
            </span>               
        </OverlayTrigger>
    
        <Navbar.Toggle />

        <div className="dialog-title" />

        <Navbar.Collapse className="justify-content-end">
            <Nav.Item className="item">
                <OverlayTrigger placement="bottom" delay={200} overlay={
                    <Tooltip>Home</Tooltip>
                }>
                    <Nav.Link onClick={() => nav(OpenMainPage)}><i className="fa-duotone fa-house fa-action"></i></Nav.Link>
                </OverlayTrigger>
            </Nav.Item>
            {ShowSettingsCanvas(sid, sessionInfo, props)}

            <Overlay
                show={showAccount}
                placement="bottom-end"
                rootClose={true}
                onHide={() => setShowAccount(false)}
                target={targetAccount}
            >
                <Popover bsPrefix="nav-popover" style={{ marginTop: '18px' }} ref={profileRef}>
                    <Popover.Body bsPrefix="nav-popover-body">
                        <Container fluid className="gx-0">
                            <Row>
                                <Col className='col-2 align-top'>
                                    <span className="avatar">
                                        <span id="intitials">{GetInitials(sessionInfo)}</span>
                                    </span>
                                </Col>
                                <Col className='col-10'>
                                    <b>{GetFullName(sessionInfo)}</b>
                                    <Form.Label>{GetAccountName(sessionInfo)}</Form.Label>
                                    <Button variant="primary-outline" onClick={logout}>Log Out</Button>
                                    <Button variant="primary-outline" style={{ display: "none" }}>Switch Firm</Button>
                                </Col>
                            </Row>
                        </Container>
                    </Popover.Body>

                    <Popover.Body bsPrefix="nav-popover-body">
                        <Container fluid className="gx-0">
                            <Row>
                                <Col className='col-12'>
                                    <Form.Label>User Preferences</Form.Label>
                                </Col>
                            </Row>

                            <Row>
                                <Col className='col-8'>
                                    <span>Dark Theme</span>
                                </Col>
                                <Col className='col-4 align-right'>
                                    {/*<BootstrapSwitchButton checked={isDarkTheme()} onChange={(checked:boolean) => {toggleDarkTheme(checked)}} onstyle="outline-success" offstyle="outline-danger" size="xs"/>*/}

                                    <Form.Check
                                        type="switch"
                                        id="dark-mode-switch"
                                        aria-label="Check this switch"
                                        onChange={toggleDarkTheme}
                                        defaultChecked={isDarkTheme()}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </Popover.Body>
                </Popover>
            </Overlay>
            <OverlayTrigger placement="bottom" delay={200} overlay={
                <Tooltip>Account</Tooltip>
            }>
                <Nav.Item className="item avatar" style={{ marginLeft: '10px' }} ref={refAccount} onClick={handleAccountClick}>
                    <span id="intitials">{GetInitials(sessionInfo)}</span>
                </Nav.Item>
            </OverlayTrigger>
        </Navbar.Collapse>
    </Navbar>
</>
}

export default TopBar;